import * as React from "react";
import { Link } from "react-router-dom";
import * as _ from "lodash";
import {
  Col,
  PageHeader,
  Row,
  Button,
  Form,
  Progress,
  Divider,
  Modal,
} from "antd";

// common
import { QUIZ_DATA } from "../common/data";
import { ITest } from "../common/types";
import { ShareFacebook, ShareTwitter } from "../common";

// local
import TestCard from "./card";

const QUIZ_SIZE = QUIZ_DATA.length;
const INITIAL_RESULTS = new Array(QUIZ_SIZE).fill(false);

const TestPage = () => {
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const [results, setResults] = React.useState<boolean[]>(INITIAL_RESULTS);
  const [visible, setVisible] = React.useState<boolean>(false);

  const [form] = Form.useForm();

  const QUIZ_CORRECT_SIZE = results.filter(Boolean).length;
  const RESULT_SHARE_TEXT = `誰でも無料で受けられるオンラインセキュリティテストの結果は ${QUIZ_SIZE} 問中 ${QUIZ_CORRECT_SIZE} 問正解でした。あなたも挑戦してみませんか？ #CyTrain`;

  return (
    <>
      <PageHeader
        title="確認テスト"
        extra={[<ShareFacebook />, <ShareTwitter />]}
      />
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={() => {
          window.scrollTo(0, 0);
          setVisible(false);
        }}
        okText="解説を見る"
        cancelText="閉じる"
      >
        <Divider>確認テスト結果</Divider>
        <Row justify="center" style={{ marginBottom: 8 }}>
          <div>
            <b style={{ fontSize: "1.2rem" }}>
              {QUIZ_CORRECT_SIZE} / {QUIZ_SIZE} 問
            </b>{" "}
            正解しました！
          </div>
        </Row>
        <Row justify="center" style={{ marginBottom: 24 }}>
          <Progress
            percent={(QUIZ_CORRECT_SIZE / QUIZ_SIZE) * 100}
            steps={QUIZ_SIZE}
            showInfo={false}
            strokeColor="#52c41a"
          />
        </Row>
        <Row justify="center" style={{ marginBottom: 8 }}>
          結果をシェアする
        </Row>
        <Row justify="center">
          <Row justify="space-around" style={{ width: "100px" }}>
            <ShareFacebook title={RESULT_SHARE_TEXT} />
            <ShareTwitter title={RESULT_SHARE_TEXT} />
          </Row>
        </Row>
        <Divider>アンケートご協力のお願い</Divider>
        卒業論文でインターネット利用者のセキュリティ意識について
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfGjPuggfBKq-wmqTBkhYV1lpAA9vKfPtjiLFljBxXaHeeasA/viewform?usp=sf_link"
          target="_blank"
          rel="noreferrer"
        >
          Google Forms
        </a>
        にてアンケート調査を行っております。
        <br />
        <br />
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfGjPuggfBKq-wmqTBkhYV1lpAA9vKfPtjiLFljBxXaHeeasA/viewform?usp=sf_link"
          target="_blank"
          rel="noreferrer"
        >
          <Button type="primary" block danger>
            アンケートに協力する
          </Button>
        </a>
        <br />
        <br />
        またご感想やご意見等は
        <Link to="/about">このサイトについて</Link>からご連絡ください。
        よろしくお願いします。
      </Modal>
      <Form
        form={form}
        onFinish={(values: any) => {
          const check: any = Object.values(values).map(
            (value: any, i: number) => {
              const tmp = Array.isArray(value) ? value : [value];
              return _.isEqual(tmp, QUIZ_DATA[i].answer);
            }
          );
          setResults(check);
          setSubmitted(true);
        }}
      >
        <Row justify="center" gutter={[24, 24]}>
          <Col style={{ maxWidth: 800 }}>
            <div style={{ textAlign: "right", marginRight: "8px" }}>
              全部で {QUIZ_SIZE} 問あります。出題範囲はすべてです。
            </div>
            {QUIZ_DATA.map((test: ITest, i: number) => (
              <Col
                flex="auto"
                style={{ marginBottom: "20px" }}
                key={test.title}
              >
                <TestCard
                  test={test}
                  id={i}
                  submitted={submitted}
                  results={results}
                />
              </Col>
            ))}
            <Row justify="center">
              <Col>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setVisible(true)}
                    size="large"
                  >
                    提出して回答を確認
                  </Button>

                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfGjPuggfBKq-wmqTBkhYV1lpAA9vKfPtjiLFljBxXaHeeasA/viewform?usp=sf_link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button
                      type="primary"
                      size="large"
                      style={{ marginLeft: 20 }}
                      danger
                      hidden={!submitted}
                    >
                      アンケートに協力する
                    </Button>
                  </a>
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default TestPage;
